import React from 'react';
import LazyMetrics from '../LazyMetrics';
import EducatorsWithOpenProjectGroup from './EducatorsWithOpenProject';
import EducatorsWithCompletedProjectGroup from './EducatorsWithCompletedProject';
import EducatorEvaluationsCompletedGroup from './EducatorEvaluationsCompleted';
import PartnerInvitationsWithResponseGroup from './PartnerInvitationsWithResponse';
import PartnersEngagingWithEducatorsGroup from './PartnersEngagingWithEducators';

export default function Educators(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="% of educators who shared a project"
        columns={3}
      >
        <EducatorsWithOpenProjectGroup {...params} />
      </LazyMetrics>
      <LazyMetrics
        title="% of educators with a completed project"
        columns={3}
      >
        <EducatorsWithCompletedProjectGroup {...params} />
      </LazyMetrics>
      <LazyMetrics
        title="% of educator evaluations completed"
        columns={3}
      >
        <EducatorEvaluationsCompletedGroup {...params} />
      </LazyMetrics>
      <LazyMetrics
        title="% invitations responded to by a partner"
        columns={3}
      >
        <PartnerInvitationsWithResponseGroup {...params} />
      </LazyMetrics>
      <LazyMetrics
        title="% partners engaging with educators"
        columns={3}
      >
        <PartnersEngagingWithEducatorsGroup {...params} />
      </LazyMetrics>
    </>
  );
}
